import { HostName } from "@microsoft/teams-js";

/**
 * The host name.
 * @example "teamsModern"
 * TODO: Use platform agnostic host name.
 */
export { HostName };